export default "__VITE_ASSET__DQ7nV9iE__"